import type { HTMLAttributes } from 'react';
import { cn } from '@/shared/lib/cn';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

// Bloco shimmer reutilizavel (atomo do design system de loading).
// - bg-gray-100: tom neutro leve; nao compete com cards de conteudo real
//   (que ficam em bg-white e usam gray-200 para bordas/divisores).
// - animate-pulse-soft: opacity 1->0.7 em 1.8s ease-in-out (mais sutil
//   que o animate-pulse default do Tailwind que vai ate 0.5).
// Wrapper que renderiza varios destes deve ser bg-white SEM shadow para
// se diferenciar do card real (regra: skeleton eh mais leve que conteudo).
// Use aria-busy="true" no container, nao aqui (cada Skeleton eh aria-hidden).
export const Skeleton = ({ className, ...rest }: SkeletonProps) => (
  <div
    aria-hidden="true"
    className={cn('animate-pulse-soft rounded-md bg-gray-100', className)}
    {...rest}
  />
);
